'use client';

import React, { memo, useMemo } from 'react';
import AppIcon from './AppIcon';
import AppImage from './AppImage';

interface AppLogoProps {
  src?: string;
  iconName?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
  variant?: 'dark-bg' | 'light-bg'; // dark-bg = white logo, light-bg = standard logo
}

const AppLogo = memo(function AppLogo({
  src = '/assets/images/CX_LOGO_WHITE_BG-1774634094144-1786874560226.png',
  iconName = 'SparklesIcon',
  size = 64,
  className = '',
  onClick,
  variant = 'light-bg',
}: AppLogoProps) {
  const containerClassName = useMemo(() => {
    const classes = ['flex items-center'];
    if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
    if (className) classes.push(className);
    return classes.join(' ');
  }, [onClick, className]);

  return (
    <div className={containerClassName} onClick={onClick}>
      {src ? (
        <AppImage
          src={src}
          alt="MyGCC CX CRM Logo"
          width={size}
          height={size}
          className={`flex-shrink-0 ${variant === 'dark-bg' ? 'brightness-0 invert' : ''}`}
          priority={true}
          unoptimized={src.endsWith('.svg')}
        />
      ) : (
        <AppIcon name={iconName} size={size} className="flex-shrink-0" />
      )}
    </div>
  );
});

export default AppLogo;
